import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateJobFilterList } from '../../../actions'
import { employeeDashboardStore as store } from '../../../../store';
import FilterWithHeaderSection from '../FilterWithHeaderSection';
import './JobFilter.scss';

function JobFilter() {
    const allFilters = useSelector(state => state.filters);

    const handleJobsChange = ({selectedItems, isTransferIncluded}) => {
        store.dispatch(updateJobFilterList({ filters: selectedItems, isTransferIncluded: isTransferIncluded}));
	};

    return (
        <div className="job-filter-wrapper">
            <FilterWithHeaderSection 
                title="Jobs"
                items={allFilters.job.filters}
                onChange={handleJobsChange}
                expandIcon={(<FontAwesomeIcon icon={["far", "chevron-up"]}/>)}
            />
        </div>
    );
}


export default JobFilter;